import { Typography } from "./Typography.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Typography/Text.tsx
/**
* A text component. Underlying HTML element can be changed using the `as`
* property. Will default to be a paragraph.
*/
var Text = ({ as = "p", children, ...props }) => {
	return /* @__PURE__ */ jsx(Typography, {
		as,
		type: "body",
		...props,
		children
	});
};
//#endregion
export { Text };

//# sourceMappingURL=Text.js.map